import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { CandidateConferencePageComponent } from './candidate-conference-page.component';
import { CandidateConferenceModule } from './candidate-conference/candidate-conference.module';
import { SkeletonLoaderModule } from 'src/app/shared/skeleton-loader/skeleton-loader.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'candidateConference',
    url: '/candidateConference?c&j&jm&t&mode&sh&ws&m',
    component: CandidateConferencePageComponent,
    data: {
      requireLogin: false
    }
  }
];

@NgModule({
  declarations: [CandidateConferencePageComponent],
  imports: [
    CommonModule,
    CandidateConferenceModule,
    SkeletonLoaderModule,
    UIRouterModule.forChild({ states })
  ],
  entryComponents: [CandidateConferencePageComponent],
})
export class CandidateConferencePageModule { }
